import React, {createContext, useEffect} from "react";
import {Accordion, AccordionDetails, AccordionSummary} from "@material-ui/core";
import styled from "styled-components";
import {DetailsWidget} from "./widget/details";
import {AsessmentWidget} from "./widget/asessment";
import {useHistory, useParams} from "react-router-dom";
import {useWait} from "../../utils/wait_fn";
import {DetailsInterface, ResultInterface} from "../../interface/challenge/details";
import {HttpServer} from "../../net/http_server";
import backImg from "../../assets/imgs/back_img.png"


export const MsgPage: React.FC = () => {
    const params = useParams<{ id: string }>();
    const history = useHistory();
    const {data, request} = useWait<ArbitrationInterface>(HttpServer.assessmentResult)
    useEffect(() => {
        request(params.id);
    }, [])
    return (
        <ArbitrationProvider.Provider value={data}>
            <WapStyle>
                <PaddingStyle onClick={history.goBack}>
                    <img src={backImg} alt=""/>
                    Back
                </PaddingStyle>
                <AccordionRootStyle defaultExpanded={true}>
                    <AccordionStyle
                        aria-controls="panel2a-content"
                        id="panel2a-header"
                    >
                        Details
                    </AccordionStyle>
                    <AccordionDetails>
                        <DetailsWidget model={data?.claim}/>
                    </AccordionDetails>
                </AccordionRootStyle>
                <AccordionRootStyle defaultExpanded={true}>
                    <AccordionStyle
                        aria-controls="panel2a-content"
                        id="panel2a-header"
                    >
                        Asessment results
                    </AccordionStyle>
                    <AccordionDetails>
                        <AsessmentWidget resultList={data?.result}/>
                    </AccordionDetails>
                </AccordionRootStyle>


            </WapStyle>
        </ArbitrationProvider.Provider>

    );
}

export interface ArbitrationInterface {
    claim?: DetailsInterface,
    result: ResultInterface[],
}

export const ArbitrationProvider = createContext<ArbitrationInterface>({claim: undefined, result: []});

const WapStyle = styled.div`
  //padding:20px 30px;
  box-sizing: border-box;
  background-color: #E5E8F5;
`


const AccordionRootStyle = styled(Accordion)`
  margin-bottom: 40px !important;

  &.MuiAccordion-root:before {
    display: none;
  }

  &.MuiAccordion-root {
    box-shadow: none;

    .MuiAccordionDetails-root {
      padding: 0;
    }
  }
`

const PaddingStyle = styled.div`
  padding-left: 10px;
  padding-top: 30px;
  padding-bottom: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  img{
    display: block;
    width: 22px;
    height: 20px;
    margin-right: 10px;
  }
  font-size: 16px;
  font-weight: bold;
  color: #666660;
  line-height: 28px;
`

const AccordionStyle = styled(AccordionSummary)`
  background-color: #EAF2FF !important;

  .MuiAccordionSummary-content {
  }
`
